module.exports = __webpack_public_path__ + "static/img/5742_phase_function_Paper_PointsHejduk_Prediction.df4b149.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5742_phase_function_Paper_PointsHejduk_Prediction.png
// module id = qPlb
// module chunks = 0